import styled from 'styled-components';
import colors from 'constants/colors';

export const BillItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.black5};
  row-gap: 8px;
  padding: 16px;
  margin-top: 16px;

  .title {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .coupon, .ratePlan, .discount {
    color: ${colors.red};
  }
`;

export const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .description {
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .transaction {
    width: 35%;
    min-width: 150px;
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.grey};
  }

  .status {
    width: 13%;
    min-width: 120px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 10px;
  }

  .date {
    width: 22%;
    min-width: 145px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.grey};
    padding-left: 10px;
  }

  .action {
    width: 42%;
    min-width: 240px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;
  }

  .price {
    width: 16%;
    min-width: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: ${colors.grey};
    padding-left: 10px;
    .amount {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      width: 100px;
      text-align: right;
    }
  }

  .header {
    color: ${colors.silver};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .approval {
    color: ${colors.green};
  }

  .warning {
    color: ${colors.red};
  }

  .normal {
    color: ${colors.white};
  } 

  .lineThrough {
    text-decoration: line-through;
  }

  
  @media only screen and (max-width: 1400px) {

    .transaction {
      min-width: 140px;
    }

    .status {
      min-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .action {
      min-width: 220px;
    }
  }
`;

export const BillOfSaleContainer = styled.div`
  width: 100%;

  .total, .MAT, .HST {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: ${colors.black1};
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    color: ${colors.white};
  }

  .paid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background-color: ${colors.black1};
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    color: ${colors.red};
  }

  .price {
    width: 16%;
    min-width: 80px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .amount {
      width: 100%;
      width: 100px;
      text-align: right;
    }
  }
`;

export const Warning = styled.div`
  color: ${colors.red};
  font-size: 14px;
  font-weight: 600;
  font-style: italic;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
`;